import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Modal, Row, Switch, Tag } from 'antd';

import BasicButtonPrimary from 'components/BasicButtonPrimary';

const ThirdPartyConfigLayout = ({
  loading,
  form,
  translation,
  title,
  isConnected,
  hasFormChanged,
  onBack,
  onFinish,
  onValuesChange,
  children,
  showConfirmTest,
  setShowConfirmTest,
  onConfirmAndSave,
  confirmTitle = 'Xác nhận test cấu hình',
  confirmMessage = 'Test API có thể tạo giao dịch test trên hệ thống đối tác. Bạn có muốn tiếp tục?',
}) => {
  return (
    <div className='tingee-noti'>
      <Button type='default' icon={<LeftOutlined />} onClick={onBack} />
      <Card loading={loading} className='telegram-noti_content'>
        <div className='mt-2'>
          <Form form={form} layout='vertical' onFinish={onFinish} onValuesChange={onValuesChange}>
            <Row gutter={[48, 16]}>
              <Col xs={{ span: 24 }} md={{ span: 20 }} span={20}>
                <div className='section-title mb-2 mt-3'>{title}</div>
                {children}
                <Form.Item label={translation('telegram.active')} name='isEnable' valuePropName='checked'>
                  <Switch />
                </Form.Item>
                <Form.Item className='pt-1' label={translation('telegram.connectionStatus')}>
                  <Tag color={form.getFieldValue('isConnected') ? 'green' : ''}>
                    {form.getFieldValue('isConnected') ? translation('telegram.connected') : translation('telegram.notConnected')}
                  </Tag>
                </Form.Item>
                <BasicButtonPrimary
                  style={{ marginRight: 10 }}
                  className='mr-2'
                  htmlType='submit'
                  disabled={isConnected && !hasFormChanged}
                  text={translation('telegram.updateButton')}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </Card>

      <Modal
        visible={showConfirmTest}
        title={confirmTitle}
        onCancel={() => setShowConfirmTest(false)}
        footer={[
          <Button key='cancel' onClick={() => setShowConfirmTest(false)}>
            {translation('cancel')}
          </Button>,
          <Button key='confirm' type='primary' onClick={onConfirmAndSave}>
            {translation('confirm')}
          </Button>,
        ]}
      >
        <p>{confirmMessage}</p>
      </Modal>
    </div>
  );
};

export default ThirdPartyConfigLayout;
